import * as $ from 'jquery';

export function readMore() {

    const $btnReadMore = $('#read_more')
    const $containerReadMore = $('[data-read-more]')
    const desktopWidth = 1000
    const maxHeightDesktopContainer = 1300
    const maxHeightMobileContainer = 2000

    if (!$btnReadMore.length || !$containerReadMore.length) return

    init()

    function init() {

        checkWidthWindows(desktopWidth, toggleReadMore)

        $(window).resize(function() {
            checkWidthWindows(desktopWidth, toggleReadMore)
        })

        $btnReadMore.on('click', () => {
            $containerReadMore.removeClass('hidden-text')
            $containerReadMore.addClass('show-text')
            $btnReadMore.addClass('hide')
        })
    }

    function checkWidthWindows (windowWidth, toggleFn){
        if ($(window).width() < windowWidth) {
            toggleFn(maxHeightMobileContainer)
        } else {
            toggleFn(maxHeightDesktopContainer)
        }
    }


    function toggleReadMore (maxHeightContainer) {
        if ($containerReadMore[0].scrollHeight < maxHeightContainer) {
            $btnReadMore.addClass('hide')
            $containerReadMore.removeClass('hidden-text')
            $containerReadMore.addClass('show-text')
        } else {
            $btnReadMore.removeClass('hide')
            $containerReadMore.addClass('hidden-text')
            $containerReadMore.removeClass('show-text')
        }
    }
}

